import { onMounted, onUnmounted } from "vue"
import { onAngularEvent, startAngularBridge } from "@/utils/angularEmbed"
import { logout } from "@/composables/useSession"
import { workerStore } from "@/store/worker"

/**
 * Приём сообщений от Angular-гостя, живущего в iframe.
 *
 * Поднимается один раз из App.vue: эффекты глобальные (локаль и сессия всего
 * приложения).
 */
export function useAngularBridge(): void {
	let stop: (() => void) | null = null

	onMounted(() => {
		const unsubscribeLanguage = onAngularEvent("language_changed", (event) => {
			workerStore()
				.setLanguageFromAngular(event.language)
				.catch((e) => console.error(e))
		})
		// Гость потерял авторизацию и показывает свой логин. Сами мы узнали бы
		// об этом только на собственном 401, поэтому гасим сессию по объявлению.
		const unsubscribeSession = onAngularEvent("session_expired", () => {
			logout()
		})
		const stopListening = startAngularBridge()
		stop = () => {
			unsubscribeLanguage()
			unsubscribeSession()
			stopListening()
		}
	})

	onUnmounted(() => {
		stop?.()
		stop = null
	})
}
